import { useState, useCallback } from 'react';

let csvContent = 'data:text/csv;charset=utf-8,';

function descargarArchivo(dataCsv, nombre) {
   const encodedUri = encodeURI(csvContent + dataCsv);
   const link = document.createElement('a');
   link.id = nombre;
   link.href = encodedUri;
   link.download = nombre;
   link.click();
}

function getValorMostrar(registro, indice, valorMostrar_, valorNull) {
   let valor;
   let valorMostrar;
   if (typeof valorMostrar_ === 'string') {
      valor = registro[valorMostrar_];
   } else {
      valor = valorMostrar_(registro, indice);
   }
   if (valor === null) {
      if (valorNull !== undefined && valorNull !== null) {
         valorMostrar = valorNull;
      } else {
         valorMostrar = valor;
      }
   } else {
      valorMostrar = valor.toString();
   }
   return valorMostrar.replace(/\n/g, ' ');
}

async function getFilaCsv(fila, filIndex, columnas, separador) {
   const filaCsv = await columnas.reduce((currC, col, colIndex) => {
      if (colIndex === 1) {
         currC = getValorMostrar(fila, filIndex, currC.valorMostrar, currC.valorNull);
         currC += separador;
      }
      currC += getValorMostrar(fila, filIndex, col.valorMostrar, col.valorNull);
      currC += separador;
      return currC;
   });
   return filaCsv.slice(0, -1) + '\n';
}

export default function useCsv() {
   const [filaActual, setFilaActual] = useState(0);
   const [procesando, setProcesando] = useState(false);
   const [csv, setCsv] = useState(null);

   async function convertir(
      tabla,
      { columnas, separador = '|', descargarAlFinalizar = false, nombreArchivo } = {}
   ) {
      setProcesando(true);
      let dataCsv = null;
      if (columnas) {
         let header = columnas.reduce((curr, item, index) => {
            if (index === 1) {
               curr = `${curr.titulo}`;
            }
            return `${curr}${separador}${item.titulo}`;
         });
         header += '\n';
         let dataCsvA = await Promise.all(
            tabla.map(async (fila, index) => {
               setFilaActual(index + 1);
               const filaCsv = await getFilaCsv(fila, index, columnas, separador);
               return filaCsv;
            })
         );
         dataCsvA = [header, ...dataCsvA];
         dataCsv = await dataCsvA.join('');
      } else {
         dataCsv = await tabla.reduce((data, fila, index) => {
            setFilaActual(index);
            if (index === 1) {
               data = Object.keys(tabla[0]).join(separador);
               data += '\n';
            }
            data += Object.values(fila).join(separador);
            data += '\n';
            return data;
         });
      }
      setProcesando(false);
      setCsv(dataCsv);
      if (descargarAlFinalizar) {
         let nombre = `${nombreArchivo || new Date().getTime().toString()}.csv`;
         descargarArchivo(dataCsv, nombre);
      }
   }

   const convertirCb = useCallback(convertir);
   return [convertirCb, { filaActual, procesando, csv }];
}
